// Определение пола по имени — спека 02 §A1: «словарь имён → если уверенно, ставим молча
// … если неоднозначно (Саша, Женя, Валя), латиница или ник — показываем A1·2».
import { AMBIGUOUS_NAMES, NAME_GENDER_MAP } from './genderDictionary'
import type { Gender } from '../types'

const CYRILLIC_LETTERS_RE = /^[а-яё\s-]+$/i

function normalize(rawName: string): string {
  return rawName.trim().toLowerCase()
}

/**
 * Возвращает `'f' | 'm'`, если словарь уверен, иначе `null` (латиница, ник, имя не в словаре
 * или явно неоднозначное имя типа «Саша») — в этом случае экран показывает вопрос A1·2.
 */
export function guessGenderByName(rawName: string): Gender | null {
  const name = normalize(rawName)

  if (!name) {
    return null
  }

  // Имя может прийти как «Настя К.» — сверяем только первое слово, остальное (фамилия,
  // инициал с точкой) на результат не влияет.
  const firstWord = name.split(/\s+/)[0] ?? ''

  // Латиница / ник вида "kotik_99" — словарь по-русски ничего не скажет.
  if (!CYRILLIC_LETTERS_RE.test(firstWord)) {
    return null
  }

  if (AMBIGUOUS_NAMES.includes(firstWord)) {
    return null
  }

  return NAME_GENDER_MAP[firstWord] ?? null
}
